<template>
    <div class="animated fadeIn">
        <div class="card admin">
            <div class="card-header">
                Список пользователей
                <div class="pull-right" style="margin-top: 7px">
                    <button class="btn btn-secondary" :class="{ active: showFilter }" data-toggle="dropdown" href="#" @click.prevent="showFilter = !showFilter">
                        <i class="fa fa-filter"></i> Фильтр
                    </button>
                    <button v-if="currentUser.hasPermission('user.add')" class="btn btn-primary" @click.prevent="showModalAddUser">
                        <i class="fa fa-plus"></i> Добавить пользователя
                    </button>
                </div>

                <div v-if="showFilter" class="mt-3 mt-lg-1">
                    <div class="row col-12 col-lg-6">
                        <form @submit.prevent="search" сlass="form-horizontal">
                        <div class="form-group row">
                            <label class="col-6 form-control-label">Имя или фамилия</label>
                            <div class="col-6">
                                <input type="text" class="form-control" v-model="params.query">
                            </div>
                        </div>
                        <!--<div class="form-group row">-->
                            <!--<label class="col-md-3 form-control-label"></label>-->
                            <!--<div class="col-md-5">-->
                                <!--<button type="submit" class="btn btn-primary">Найти</button>-->
                            <!--</div>-->
                        <!--</div>-->
                        </form>
                    </div>
                    <div class="col-6"></div>
                </div>
            </div>
            <div class="card-block admin__list">
                <div class="row mb-1 small text-muted">
                    <div class="col-1 col-lg-1 d-none d-lg-block">Id</div>
                    <div class="col-12 col-md-8 col-lg-2">Основаная информация</div>
                    <div class="col-2 d-none d-lg-block">Компании</div>
                    <div class="col-2 d-none d-lg-block">Техцентры</div>
                    <div class="col-md-4 col-lg-1 d-none d-md-block">Телефон</div>
                    <div class="col-1 d-none d-lg-block">Роль</div>
                    <div class="col-3 d-none d-lg-block">Управление</div>
                </div>
                <loading v-if="loadingUsers" message="Загружаем пользователей..."></loading>
                <div v-else class="row mb-1 admin__list__item admin__list__item_hover-bg-gray"  v-for="user in users">
                    <div class="col-12 col-lg-1 text-lg-center">
                        <div class="avatar d-none d-lg-inline">
                            <img :src="getAvatarPath(user.avatar)" class="img-avatar">
                        </div>
                        <div>
                            <span class="badge badge-success" v-if="user.enabled">Активен</span>
                            <span class="badge badge-danger" v-else>Заблокирован</span>
                        </div>
                    </div>
                    <div class="col-6 col-md-8 col-lg-2">
                        <router-link  v-if="currentUser.hasPermission('user.view.all')"  :to="{ name: 'ViewProfile', params: { id: user.id }}">{{user.fullname}}</router-link>
                        <span v-else>{{user.fullname}}</span>
                        <div class="small text-muted">{{user.email}}</div>
                    </div>
                    <div class="col-6 col-md-4 col-lg-2">
                        <span class="badge badge-success" v-for="company in user.companies">{{company.name}}</span>
                    </div>
                    <div class="col-6 col-md-8 col-lg-2">
                        <span class="badge badge-info" v-for="(techcenter, index) in user.techcenters">
                          {{techcenter.address}}
                        <!--<tooltip effect="scale" placement="bottom" content="Отвязать техцентр от пользователя">-->
                        <!--<i @click="attachDetachTechcenter(user, techcenter, false)" class="fa fa-times detach"></i>-->
                        <!--</tooltip>-->
                        </span>
                    </div>
                    <div class="col-6 col-md-4 col-lg-1">
                        +7{{user.phone}}
                    </div>
                    <div class="col-6 col-md-8 col-lg-1">
                        <span class="badge badge-danger" v-if="user.isAdmin">Администратор</span>
                        <span class="badge badge-warning" v-if="user.role === 'supermanager'">Менеджер</span>
                        <span class="badge badge-success" v-if="user.role === 'user'">Пользователь</span>
                    </div>
                    <div class="col-6 col-md-4 col-lg-3">
                        <template v-if="currentUser.hasPermission('user.block')">
                            <loading v-if="blockUserLoading === user.id" :size="2" :message="false"></loading>
                            <template v-else>
                                <button v-if="user.enabled" class="btn btn-danger btn-sm" @click="blockUser(user, false)">
                                    <i class="fa fa-lock"></i> Заблокировать
                                </button>
                                <button v-else class="btn btn-secondary btn-sm" @click="blockUser(user, true)">
                                    <i class="fa fa-unlock"></i> Разблокировать
                                </button>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
            <div class="card-header">
                <b-pagination class="mb-0" size="md" :total-rows="usersPage.paginator.total_count" v-model="params.page" :per-page="usersPage.paginator.limit">
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
  import getUsersQuery from './../../gql/queries/getUsers.graphql'
  import blockUserMutate from './../../gql/mutations/BlockUser.graphql'
  import { storageUrl } from './../../config'
  import { mapActions, mapState } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  export default {
    computed: {
      ...mapState({
        currentUser: state => state.globalStore.user
      }),
      users () {
        return this.usersPage.users
      }
    },
    data () {
      return {
        params: {
          page: 1,
          all: false,
          query: ''
        },
        usersPage: {
          users: null,
          paginator: {
            total_count: 10
          }
        },
        blockUserLoading: false,
        showFilter: false,
        loadingUsers: false
      }
    },
    name: 'users',
    components: {
        //
    },
    methods: {
      search () {
//        this.$apollo.queries.usersPage.refetch()
      },
      /**
       * Блокировка/разблокировка пользователя
       * @param user
       * @param enabled
       */
      blockUser (user, enabled) {
        this.blockUserLoading = user.id
        this.$apollo.mutate({
          mutation: blockUserMutate,
          variables: {
            id: user.id,
            enabled: enabled
          }
        }).then((data) => {
          this.addToast({
            text: 'Изменения сохранены',
            type: 'success',
            dismissAfter: 3000
          })
          this.blockUserLoading = false
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.blockUserLoading = false
        })
      },
      /**
       * Открепить/прикрепить техцентр к пользователю
       * @param user
       * @param techcenter
       */
//      attachDetachTechcenter (user, techcenter, attach) {
//        this.$apollo.mutate({
//          mutation: attachDetachTechcenterByUserMutate,
//          variables: {
//            userId: user.id,
//            techcenterId: techcenter.id,
//            attach: attach
//          }
//        }).then((data) => {
//          this.addToast({
//            text: 'Изменения сохранены',
//            type: 'success',
//            dismissAfter: 3000
//          })
//        }).catch((error) => {
//          console.error(error)
//          this.addToast({
//            text: 'Произошла ошибка:' + error,
//            type: 'danger',
//            dismissAfter: 10000
//          })
//          this.blockUserLoading = false
//        })
//      },
      showModalAddUser () {
        this.$store.dispatch('setAdminModal', 'addUser')
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      }),
      getAvatarPath (path) {
        return storageUrl + path
      }
    },
    apollo: {
      usersPage: {
        query: getUsersQuery,
        variables () {
          return {
            page: this.params.page,
            all: this.params.all,
            query: this.params.query
          }
        },
        fetchPolicy: 'network-only',
        watchLoading (isLoading, countModifier) {
          this.loadingUsers = isLoading
        },
        update: (data) => {
          return data
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Users.vue?3ffb0186